/* eslint-disable @typescript-eslint/no-explicit-any */

import { IS_DEBUG_MODE } from "@src/config";

export const logger = {
  log: (...args: any[]) => {
    if (IS_DEBUG_MODE) {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    if (IS_DEBUG_MODE) {
      console.error(...args);
    }
  },
  warn: (...args: any[]) => {
    if (IS_DEBUG_MODE) {
      console.warn(...args);
    }
  },
};
